import {
    Building, GraduationCap, Stethoscope, Hotel, Factory, Warehouse, ShoppingBag,
    Landmark, Banknote, ServerCog, Rocket, Store,
} from "lucide-react";

const INDUSTRIES = [
    { icon: Building, label: "Corporate Offices" },
    { icon: GraduationCap, label: "Educational Institutions" },
    { icon: Stethoscope, label: "Hospitals" },
    { icon: Hotel, label: "Hotels" },
    { icon: Factory, label: "Manufacturing" },
    { icon: Warehouse, label: "Warehouses" },
    { icon: ShoppingBag, label: "Retail" },
    { icon: Landmark, label: "Government" },
    { icon: Banknote, label: "Banks" },
    { icon: ServerCog, label: "Data Centers" },
    { icon: Rocket, label: "Startups" },
    { icon: Store, label: "SMBs" },
];

export default function Industries() {
    return (
        <section id="industries" className="py-20 lg:py-28 bg-white" data-testid="industries-section">
            <div className="container-lg">
                <div className="text-center max-w-2xl mx-auto mb-12">
                    <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Industries We Serve</span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy">
                        Trusted across industries.
                    </h2>
                    <p className="mt-4 text-slate-600">
                        From small teams to sprawling campuses — CoreCyrus delivers networking that
                        matches the pace, compliance and scale of your industry.
                    </p>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
                    {INDUSTRIES.map((it, i) => (
                        <div
                            key={it.label}
                            data-testid={`industry-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="flex flex-col items-center text-center rounded-2xl border border-slate-200 bg-white p-5 hover:border-brand/40 hover:bg-brand-soft/30 hover:-translate-y-0.5 transition-[transform,background-color,border-color] duration-300"
                        >
                            <div className="w-12 h-12 rounded-full bg-brand-soft flex items-center justify-center text-brand">
                                <it.icon className="w-5 h-5" />
                            </div>
                            <div className="mt-3 text-sm font-semibold text-navy">{it.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
